import * as angular from "angular";
import {IController} from "angular";
import {Attachment} from "../../../attachments/models/attachment.model";
import {AttachmentsDialog} from "../../../attachments/services/attachments-dialog.service";

export class ImagesPopupComponent implements IController {

  attachments: Attachment[];
  isDownloadEnabled?: boolean;
  onDownload: Function;

  constructor(private attachmentsDialog: AttachmentsDialog) {
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.attachments && !changes.attachments.isFirstChange()) {
      this.$onInit();
    }
  }

  openPopup(ev) {
    this.attachmentsDialog.imagesDialog(ev, this.attachments);
  }
}

angular
  .module('bringoz.admin.commons')
  .component('imagesLinkPopup', {
    bindings: {
      attachments: '<?',
      isDownloadEnabled: '<?',
      onDownload: '&'
    },
    template: require('./images-link-popup.html').default,
    controller: ImagesPopupComponent
  });

